import { Fragment, h } from 'preact';

import { getLabel } from '../../../../labels/labelling-service';
import Parsely from '../../parsely/parsely';
import { renderInPage } from '../../parsely/renderers/render-in-page';
import { useEffectsInPage } from '../../parsely/use-effects-in-page';

import { renderModalTooltip } from './render-modal-tooltip';

export const renderMyLocalNews = ({ parselyCtx, data, type, pageState, pageActions, pageHandlers }) => (
  <Fragment>
    <Parsely
      htmlProps={data}
      state={parselyCtx.myLocalNews.state}
      parselyCommonState={parselyCtx.common.state}
      actions={{ ...parselyCtx.myLocalNews.actions, ...parselyCtx.common.actions }}
      render={renderInPage}
      useEffects={useEffectsInPage}
      widget={parselyCtx.myLocalNews.widget}
      isActiveInPage={pageState.activeBlock === type}
      pageActions={pageActions}
      blockInPageType={type}
      showMoreText={getLabel('wpn.preferences.dialog.mylocalnews.select.box.show.more')}
      showLessText={getLabel('wpn.preferences.dialog.mylocalnews.select.box.show.less')}
      ctaPrimaryLabelInPage={getLabel('mylocalnews.confirm.label')}
      confirmInPageMessage={getLabel('mylocalnews.confirm.message')}
    />
    {renderModalTooltip({
      modalTooltipData: data.modalTooltip,
      pageState,
      pageHandlers,
      htmlId: parselyCtx.myLocalNews.widget.htmlId,
    })}
  </Fragment>
);
